import { MutateOptions, useMutation, UseMutationOptions } from "@tanstack/react-query";
import { FollowCardQuery } from "../../query.types";
import { SavedAirResponseDataDTO } from "../../response.types";

import { AirSavedCardModel } from "../../../model/model";
import { savedShipmentService } from "../../api";

type FollowCardResponse = SavedAirResponseDataDTO;
type FollowCardError = Error;
type FollowCardFunc = (
  data: FollowCardQuery,
  options?: Omit<MutateOptions<FollowCardResponse, FollowCardError, FollowCardQuery>, "onSuccess"> & {
    onSuccess?: (data: AirSavedCardModel) => void;
  }
) => void;

type UseFollowCardMutationReturnType = {
  followCard: FollowCardFunc;
  followedCard: SavedAirResponseDataDTO | undefined;
  isCardFollowSuccess: boolean;
  isCardFollowError: boolean;
  isCardFollowLoading: boolean;
};

export const useFollowCardMutation = (
  mutationOptions?: Omit<UseMutationOptions<FollowCardResponse, FollowCardError, FollowCardQuery>, "mutationFn">
): UseFollowCardMutationReturnType => {
  const { data, mutate, isError, isPending, isSuccess } = useMutation<
    FollowCardResponse,
    FollowCardError,
    FollowCardQuery
  >({
    mutationFn: savedShipmentService.followCard,
    ...mutationOptions,
  });

  const followCard: FollowCardFunc = (data, { onSuccess, ...rest } = {}) => {
    mutate(data, {
      onSuccess: (response) => {
        onSuccess?.(new AirSavedCardModel(response));
      },
      ...rest,
    });
  };

  return {
    followCard,
    followedCard: data,
    isCardFollowSuccess: isSuccess,
    isCardFollowError: isError,
    isCardFollowLoading: isPending,
  };
};
